export default {
  title: 'list Students',
  search:'search ...',
  id: 'id',
  name : 'name',
  mobile:'mobile',
  lastLogin: 'last login',
  CreatedAt: 'createdAt',
  status: 'status',
  statusActive: 'active',
  statusInActive: 'inactive',
  loading:'loading ... ',
  operating:'operating',
  empty:'list is empty',
  next:'Next',
  previous:'Previous',
  success:'success',
  deleteConfirm:'Are you sure you want to delete this user?'
}
